var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import classNames from 'classnames';
import { default as React } from 'react';
import { MedicationStatus } from '../Contracts/MedicationModels';
import { groupData } from '../Shared/MedicationsHelpers';
import styles from './MedicationsSummaryList.module.css';
import { MedicationSummaryListItem } from './MedicationSummaryListItem';
var SummaryListItem = function (props) {
    var _a;
    var _b = __read(props.group, 2), status = _b[0], items = _b[1];
    status = status.toLowerCase();
    // don't render empty status groups
    if (items.length <= 0)
        return null;
    var doNotColour = ['stopped', 'enteredInError'];
    var countClass = classNames((_a = {},
        _a[styles.countNew] = !doNotColour.includes(status),
        _a[styles.countError] = status === MedicationStatus.EnteredInError,
        _a));
    return (React.createElement("div", { className: styles.group },
        React.createElement("div", { className: styles.groupHeading },
            status === MedicationStatus.EnteredInError ? 'Entered in error' : status,
            " (",
            React.createElement("span", { className: countClass }, items.length),
            ")"),
        React.createElement("div", { className: styles.groupItems }, items.map(function (item, index) {
            return (React.createElement(MedicationSummaryListItem, { key: 'actions-' + index, serviceAuthoringSystem: props.serviceAuthoringSystem, serviceAuthoringSystemForeignKey: props.serviceAuthoringSystemForeignKey, encounterAuthoringSystem: props.encounterAuthoringSystem, encounterAuthoringSystemForeignKey: props.encounterAuthoringSystemForeignKey, patient: props.patient, filterState: props.filterState, selectedId: props.selectedId, medicationsSummaryResponse: item, medicationTimeLineState: props.medicationTimeLineState, onClick: props.onClick, saveMedicationsToReprescribe: props.saveMedicationsToReprescribe, saveFreeTextMedicationToReprescribe: props.saveFreeTextMedicationToReprescribe, stopMedication: props.stopMedication, onMedicationDeleted: props.onMedicationDeleted, deleteMedication: props.deleteMedication, canReprescribe: props.canReprescribe, onReprescribe: props.onReprescribe, controlledMedicationHandler: props.controlledMedicationHandler }));
        }))));
};
export var MedicationsSummaryList = function (props) {
    if (props.data === null)
        return null;
    var groups = groupData(props.data);
    var onClick = function (event, medicationId) {
        event.stopPropagation();
        event.preventDefault();
        props.onClick(medicationId);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.groups }, __spreadArray([], __read(groups), false).map(function (group) {
                return (React.createElement(SummaryListItem, { key: group[0], group: group, onClick: onClick, patient: props.patient, stopMedication: props.stopMedication, onMedicationDeleted: props.onMedicationDeleted, deleteMedication: props.deleteMedication, selectedId: props.selectedId, saveMedicationsToReprescribe: props.saveMedicationsToReprescribe, saveFreeTextMedicationToReprescribe: props.saveFreeTextMedicationToReprescribe, canReprescribe: props.canReprescribe, onReprescribe: props.onReprescribe, serviceAuthoringSystem: props.serviceAuthoringSystem, serviceAuthoringSystemForeignKey: props.serviceAuthoringSystemForeignKey, encounterAuthoringSystem: props.encounterAuthoringSystem, encounterAuthoringSystemForeignKey: props.encounterAuthoringSystemForeignKey, filterState: props.filterState, medicationTimeLineState: props.medicationTimeLineState, controlledMedicationHandler: props.controlledMedicationHandler }));
            })))));
};
